import React, { useState } from "react";
import { Box } from "@mui/material";
import { Carousel } from "react-responsive-carousel";

import Indicator from "./Indicator";

import useCampaignImages from "../../hooks/useCampaignImages";

import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function CampaignsCarousel() {
  const { campaignImages } = useCampaignImages();
  const [activeIndex, setActiveIndex] = useState(0);

  const updateActiveIndex = (index) => setActiveIndex(index);

  if (campaignImages.length === 0) {
    return <Box></Box>
  }

  return (
    <Box>
      <Carousel
        autoPlay={true}
        dynamicHeight={true}
        infiniteLoop={true}
        interval={4000}
        showArrows={false}
        showStatus={false}
        showIndicators={false}
        showThumbs={false}
        swipeable={true}
        stopOnHover={true}
        selectedItem={activeIndex}
        onChange={updateActiveIndex}
      >
        {campaignImages.map((image) => (
          <div>
            <a href={image.link} >
              <div>
                <img
                  src={image.src}
                  alt={image.alt}
                  key={image.alt}
                  style={{ objectFit: "cover" }}
                />
              </div>
              </a>
          </div>
        ))}
      </Carousel>
      <Box display="flex" justifyContent="center" mt={1.5}>
        {campaignImages.map((_, index) => (
          <Indicator
            key={index}
            onClickHandler={() => updateActiveIndex(index)}
            isSelected={index === activeIndex}
            index={index}
            label={`Slide ${index + 1}`}
          />
        ))}
      </Box>
    </Box>
  );
}
